import emailjs from '@emailjs/browser';

// Contact form validation and email sending service
export const contactService = {
  // Validate contact form data
  validateContactForm: (formData) => {
    const errors = {};

    // Name validation
    if (!formData.name || formData.name.trim().length === 0) {
      errors.name = 'Name is required';
    } else if (formData.name.trim().length < 2) {
      errors.name = 'Name must be at least 2 characters long';
    }

    // Email validation
    if (!formData.email || formData.email.trim().length === 0) {
      errors.email = 'Email is required';
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        errors.email = 'Please enter a valid email address';
      }
    }

    // Subject validation
    if (!formData.subject || formData.subject.trim().length === 0) {
      errors.subject = 'Subject is required';
    } else if (formData.subject.trim().length < 5) {
      errors.subject = 'Subject must be at least 5 characters long';
    }

    // Message validation
    if (!formData.message || formData.message.trim().length === 0) {
      errors.message = 'Message is required';
    } else if (formData.message.trim().length < 10) {
      errors.message = 'Message must be at least 10 characters long';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  },

  // Send email using EmailJS
  sendEmail: async (formData) => {
    try {
      // EmailJS configuration
      const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'your_public_key';
      const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID || 'your_service_id';
      const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'your_template_id';

      // Check if EmailJS is properly configured
      if (publicKey === 'your_public_key' || serviceId === 'your_service_id' || templateId === 'your_template_id') {
        console.warn('EmailJS not configured. Using fallback simulation.');
        // Fallback simulation for development
        await new Promise(resolve => setTimeout(resolve, 2000));
        return {
          success: true,
          message: 'Thank you for your message! We\'ll get back to you soon.'
        };
      }

      // Initialize EmailJS with public key
      emailjs.init(publicKey);

      // Prepare email template parameters
      const templateParams = {
        from_name: formData.name,
        from_email: formData.email,
        subject: formData.subject,
        message: formData.message,
        reply_to: formData.email
      };

      // Send email using EmailJS
      const response = await emailjs.send(serviceId, templateId, templateParams, publicKey);
      
      if (response.status === 200) {
        return {
          success: true,
          message: 'Thank you for your message! We\'ll get back to you soon.'
        };
      } else {
        throw new Error('Email sending failed');
      }
      
    } catch (error) {
      console.error('Email sending error:', error);
      return {
        success: false,
        message: 'Failed to send email. Please try again or contact us directly.'
      };
    }
  },

  // Submit contact form (main function)
  submitContactForm: async (formData) => {
    try {
      // First validate the form
      const validation = contactService.validateContactForm(formData);
      if (!validation.isValid) {
        return {
          success: false,
          message: 'Please check your form inputs and try again.',
          errors: validation.errors
        };
      }

      // Send the email
      const emailResult = await contactService.sendEmail(formData);
      return emailResult;

    } catch (error) {
      console.error('Contact form submission error:', error);
      return {
        success: false,
        message: 'Something went wrong. Please try again.'
      };
    }
  }
};

export default contactService; 